import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArchiveCatalogVolumeCodeRule } from '../models/archive/archive-catalog-volume-code-rule.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ArchiveCatalogVolumeCodeRuleService extends RequestService<ArchiveCatalogVolumeCodeRule> {
  static PATH = '/archive/catalog/volume/code/rule';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(
      httpClient,
      ArchiveCatalogVolumeCodeRuleService.PATH,
      globalService.debugUrl
    );
  }
}
